import {
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_REQUEST,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_SUCCESS,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_FAILURE,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_CLEAR,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_REQUEST,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_SUCCESS,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_FAILURE,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_CLEAR,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_QUEUE
)
